import React from "react";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";
import Modalstyle from "./modal.module.scss";
import MonthlyKpiBarChart from "../chart/MonthlyKpiBarChart";
import { kpiReport, buttonName } from "../../locales/en";

const MonthlyKpiGraphReportModal = ({ isOpen, toggle }) => {
  const footerButtons = [
    {
      label: buttonName?.close,
      className: "btn btn-secondary",
      onClick: () => toggle(false)
    }
  ];

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={kpiReport?.kpiGraphModal?.title}
      modalClassName="modal-xl h-auto"
      bodyClassName={Modalstyle.refMonthlySingleContent}
      footerButtons={footerButtons}
    >
      <MonthlyKpiBarChart />
    </CommonModal>
  );
};

MonthlyKpiGraphReportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default MonthlyKpiGraphReportModal;
